import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
// import './plugins/vconsole';
// import './plugins/sentry';
import './plugins/vant';
import './utils/codepulse';

// Cathay 可回溯 SDK 初始化（只初始化一次，userId 和 businessNo 由路由守卫绑定）
import { initRecorder } from '@/core/recorder';
initRecorder();

Vue.config.productionTip = false;

new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app');
